import { render } from "./marketplaceheader.vue?vue&type=template&id=9e9a56be"
import script from "./marketplaceheader.vue?vue&type=script&lang=js"
export * from "./marketplaceheader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__